<div class="eui-table-paginator">

    <div class="eui-table-paginator__page-size-selector">
        {{ 'eui.euitable.ITEMS-PER-PAGE' | translate }}&nbsp;
        <eui-dropdown>
            <button euiButton euiBasicButton euiPrimary euiSizeS>
                <span euiLabel>{{ pageSize }}</span>
                <span euiIcon iconClass="eui-icon eui-icon-caret-down" aria-label="Select Items per page"></span>
            </button>
            <eui-dropdown-content>
                <div euiList>
                    <button euiListItem euiSizeS *ngFor="let pageSizeOption of pageSizeOptions" (click)="changePageSize(pageSizeOption)">{{ pageSizeOption }}</button>
                </div>
            </eui-dropdown-content>
        </eui-dropdown>
    </div>

    <div class="eui-table-paginator__page-navigation">
        <div class="eui-table-paginator__page-navigation-item">
            <button euiButton euiIconButton euiBasicButton euiRounded euiPrimary [attr.disabled]="page === 0 || length === 0 ? 'disabled' : null" (click)="goFirstPage()">
                <span euiIcon iconClass="eui-icon eui-icon-caret-first" aria-label="Go to first page"></span>
            </button>
        </div>
        <div class="eui-table-paginator__page-navigation-item">
            <button euiButton euiIconButton euiBasicButton euiRounded euiPrimary [attr.disabled]="page === 0 || length === 0 ? 'disabled' : null" (click)="goPreviousPage()">
                <span euiIcon iconClass="eui-icon eui-icon-caret-left" aria-label="Go to previous page"></span>
            </button>
        </div>
        <div *ngIf="hasPageNumberNavigation" class="eui-table-paginator__page-navigation-page-item">
            <button *ngFor="let pageNumber of pageNumberNavigation" euiButton euiBasicButton euiPrimary euiRounded euiIconButton [euiOutline]="pageNumber === page" (click)="goToPage(pageNumber)">
                {{ pageNumber + 1 }}
            </button>
        </div>
        <div class="eui-table-paginator__page-navigation-item">
            <button euiButton euiIconButton euiBasicButton euiRounded euiPrimary [attr.disabled]="page + 1 === nbPage || length === 0 ? 'disabled' : null" (click)="goNextPage()">
                <span euiIcon iconClass="eui-icon eui-icon-caret-right" aria-label="Go to next page"></span>
            </button>
        </div>
        <div class="eui-table-paginator__page-navigation-item">
            <button euiButton euiIconButton euiBasicButton euiRounded euiPrimary [attr.disabled]="page + 1 === nbPage || length === 0 ? 'disabled' : null" (click)="goLastPage()">
                <span euiIcon iconClass="eui-icon eui-icon-caret-last" aria-label="Go to last page"></span>
            </button>
        </div>
    </div>

    <div class="eui-table-paginator__page-range">
        {{ 'eui.euitable.SHOWING-RANGE' | translate :{ range: range } }}
    </div>
</div>
